import ErrorElement from '@pages/error';
import Layout from '../components/layout/Layout';
import FormTabs from '../pages/tab/FormTabs';
import DocumentWrapper from '../pages/docs/DocumentWrapper';
import { Navigate } from 'react-router-dom';
import FeeOutput from '../pages/feeOutput';
import TitleCheck from '../pages/titlecheck';
import Login from '../pages/login';
import Signup from '../pages/signup';
import DocsOutput from '../pages/docsOutput';
import Fee from '../pages/fees';
import EmailVerification from '../pages/mfa_verification';
import VerifyUser from '../pages/verifyUser';
import TitleOutput from '../pages/titleOutput';
import ChangePassword from '../pages/changePassword';
import ForgetPassword from '../pages/forgetPassword';
import Home from '../pages/home';
import Dashboard from '../pages/dashboard';
import MultiStepForm from '../pages/multiStepForm';
import MultiPartFormOutput from '../pages/multiPartFormOutput';
import AutoLogout from '../components/logout/autoLogout';
import PastTransactions from '../pages/pastTransactions';

export const AppRoutes = [
  {
    errorElement: <ErrorElement />,
    children: [
      {
        path: '/',
        element: <AutoLogout />,
        errorElement: <ErrorElement />,
        children: [
          {
            path: '/',
            key: 'home',
            element: < Home/>,
            errorElement: <ErrorElement />
          },
          {
            path: 'dashboard',
            key: 'dashboard',
            element: <Layout> <Dashboard /> </Layout>,
            errorElement: <ErrorElement />
          },
          {
            path: 'past-transactions',
            key: 'past-transactions',
            element: <Layout> <PastTransactions /> </Layout>,
            errorElement: <ErrorElement />
          },
          {
            path: 'multiStepForm',
            key: 'multiStepForm',
            element:  <MultiStepForm />,
            errorElement: <ErrorElement />,
          },
          {
            path: 'multiStepFormOutput',
            key: 'multiStepFormOutput',
            element: <MultiPartFormOutput />,
          },
          {
            path: 'forms',
            key: 'forms',
            element: <FormTabs />,
            children: [
              {
                index: true,
                element: <Navigate to="fees" replace />,
              },
                        {
                path: 'fees',
                key: 'fees',
                element: <Fee />,
                children: [
                  {
                    path: 'feesOutput',
                    key: 'feesOutput',
                    element: <FeeOutput />,
                  }
                ]
              },
              {
                path: 'docs',
                key: 'docs',
                element: <DocumentWrapper />,
                children: [
                  {
                    path: 'docsOutput',
                    key: 'docsOutput',
                    element: <DocsOutput />,
                  }
                ]
              },
              {
                path: 'lien-check',
                key: 'lien-check',
                element: <TitleCheck />,
                children: [
                  {
                    path: 'titleOutput',
                    key: 'titleOutput',
                    element: < TitleOutput />,
                  }
                ]
              },
            ],
          },
        ]
      },
      {
        path: 'login',
        key: 'login',
        element: <Login />,
        errorElement: <ErrorElement />
      },
      {
        path: 'signup',
        key: 'signup',
        element: <Signup />,
        errorElement: <ErrorElement />
      },
      {
        path: 'verifyEmail',
        key: 'verifyEmail',
        element: <EmailVerification />,
        errorElement: <ErrorElement />
      },
      {
        path: 'verifyUser',
        key: 'verifyUser',
        element: <VerifyUser />,
        errorElement: <ErrorElement />
      },
      {
        path: 'resetPassword',
        key: 'resetPassword',
        element: <ChangePassword />,
        errorElement: <ErrorElement />
      },
      {
        path: 'forgotPassword',
        key: 'forgotPassword',
        element: <ForgetPassword />,
        errorElement: <ErrorElement />
      },
      {
        path: '*',
        element: <ErrorElement />,
        errorElement: <ErrorElement />,
        key: 'errors'
      }
    ]
  }
];

const _getRoutePathById = (
  routeCfg,
  acc,
  id
) => {
  const rawCurrentPath = !routeCfg.path
    ? acc
    : routeCfg.path[0] === '/' || acc[acc.length - 1] === '/'
      ? `${acc}${routeCfg?.path}`
      : `${acc}/${routeCfg?.path}`;
  const currentPath = rawCurrentPath.replace('//', '/');

  if (routeCfg?.key && routeCfg?.key === id) {
    return currentPath;
  }
  if (routeCfg?.children) {
    for (const routeChild of routeCfg.children) {
      const path = _getRoutePathById(routeChild, currentPath, id);
      if (path) {
        return path;
      }
    }
  }
  return null;
};

export const getRoutePathById = (() => {
  const memo = {};

  return (id) => {
    const cachedRoute = memo[id];
    if (cachedRoute) {
      return cachedRoute;
    }

    for (const routeCfg of AppRoutes) {
      const path = _getRoutePathById(routeCfg, '', id);
      if (path) {
        return path;
      }
    }
    throw new Error('path cannot be found');
  };
})();
